const utils = {};

utils.getWebexOpenLink = () => `webexteams://im?email=${process.env.WEBEX_EMAIL}&text=Hello`;

export default utils;
